export default __webpack_public_path__ + "static/media/throat-chakra.ea3b7898.png";